export default function (context, errorText) {
    return new Promise((resolve => {
        window.app.$confirm(errorText, 'Платная услуга', {
            confirmButtonText: 'Перейти',
            cancelButtonText: 'Отмена',
            type: 'warning'
        }).then(() => {
            resolve(true);
            document.location.href = '/tourclient/dictionary/#/admin/features';
        }).catch(() => {
            resolve(false);
        });
    }))


}
